<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="/static/logo-agroforestcape.png" alt="Agroforestcape" width="120" height="120">
                  <h2 class="flex my-4 primary--text">Agroforestcape</h2>
                </div>                
                <v-form>
                  <v-text-field prepend-icon="email" name="login" label="Email" type="email" v-model="model.email"></v-text-field>
                  <small v-if="!isRegex" class="alert">Masukan Alamat Email. contoh: agroforestcape@gmail.com</small>

                  <v-text-field prepend-icon="lock" name="password" label="Password" id="password" type="password" v-model="model.password"></v-text-field>
                  <small v-if="!isPassword" class="alert">Password Minimal 8 digit</small>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn block color="primary" @click="login" :loading="loading" :disabled='!isComplete'>Login</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <small>Not have an account? <a href="#">Register</a></small> -->
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {HTTP} from '../../http-common';

export default {
  data: () => ({
    loading: false,
    model: {
      email: null,
      password: null
    },

    // Form Check
    reg: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  }),

  computed: {
    isComplete () {
      return (this.model.email && this.reg.test(this.model.email)) && (this.model.password && this.model.password.length > 7 && this.model.password.length < 33);
    },
    
    isRegex () {
      return (this.model.email && this.reg.test(this.model.email));
    },

    isPassword () {
      return (this.model.password && this.model.password.length > 7);
    },

  },

  methods: {
    login () {
      localStorage.userEmail = this.model.email
      console.log("data email : ", localStorage.userEmail)  
      setTimeout(() => {
        window.getApp.$emit('APP_LOGIN_SUCCESS');
      }, 1000);
    }
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }

  h2{
    text-align: center;
  }
</style>
